import { useEffect, useState } from 'react';

function useSepararNomeETipo(nomeComTipo: string) {
    const [nome, setNome] = useState('');
    const [tipo, setTipo] = useState('');

    const separarNomeETipo = (nomeComTipo: string) => {  
        const regex = /^(.*?)\[(.*?)\]$/;
        const match = nomeComTipo.match(regex);

        if (match) {
            
            setNome(match[1]); 
            setTipo(match[2]); 
        } else {
            
            setNome(nomeComTipo);
            setTipo(''); 
        }
    };
    
    useEffect(() => {
        separarNomeETipo(nomeComTipo);
    }, [nomeComTipo]);

    
    return { nome, tipo };
}

export default useSepararNomeETipo;
